/**
 * Sliders Module
 * All Splide slider initializations
 */

import { Splide } from "@splidejs/splide";
import { animateHeroContent, animateThumbnail } from "./animations.js";

export function initSliders() {
  console.log("Initializing sliders...");

//   initProgramStudySlider();
//   initHeroNewsSlider();
  initHeroSlider();
  initProductTerbaruSlider();
  initProductGallerySlider();
  initProductCategoriesSlider();
  initBrandSlider();
  initPartnerSlider();
  initBenefitPartnerSlider();
  initTermPartnerSlider();
//   initPartnershipSlider();
//   initTestimonySlider();
//   initAboutTeamSlider();
//   initArticleSlider();
//   initFilterArticleSlider();
}

// function initProgramStudySlider() {
//   const programStudySlider = document.querySelectorAll(".programStudySlider");
//   programStudySlider.forEach((element) => {
//     new Splide(element, {
//       perPage: 4,
//       gap: "24px",
//       breakpoints: {
//         991: {
//           perPage: 1,
//           drag: false,
//         },
//       },
//     }).mount();
//   });
// }

// function initHeroNewsSlider() {
//   const slideHeroNews = document.querySelectorAll(".slideHeroNews");
//   slideHeroNews.forEach((element) => {
//     new Splide(element, {
//       perPage: 1,
//       gap: "24px",
//     }).mount();
//   });
// }

function initProductTerbaruSlider() {
  const sliders = document.querySelectorAll(".splideProductTerbaru");
  if (!sliders.length) return;

  sliders.forEach((element) => {
    const slideCount = element.querySelectorAll(".splide__slide").length;

    new Splide(element, {
      type: "slide",
      perPage: 5,
      perMove: 5,
      gap: "20px",
      arrows: true,
      pagination: true,
      autoplay: false,
      drag: true,
      snap: true,
      breakpoints: {
        1024: {
          perPage: 3,
          perMove: 3,
        },
        768: {
          perPage: 2,
          perMove: 2,
          gap: "16px",
        },
        480: {
          perPage: 2,
          perMove: 2,
          gap: "20px",
        },
      },
    }).mount();
  });
}

function initProductGallerySlider() {
  const mainElements = document.querySelectorAll(".splideProductMain");
  if (!mainElements.length) return;

  mainElements.forEach((mainEl) => {
    mountProductGallery(mainEl);
  });
}

function mountProductGallery(mainEl) {
  const thumbEl = mainEl.closest(".product-gallery")?.querySelector(".splideProductThumb");

  // Hapus resize listener sebelumnya agar tidak menumpuk
  if (mainEl._resizeHandler) {
    window.removeEventListener("resize", mainEl._resizeHandler);
    delete mainEl._resizeHandler;
  }

  const mainSlider = new Splide(mainEl, {
    type: "slide",
    perPage: 1,
    arrows: false,
    pagination: false,
    drag: true,
  });

  if (thumbEl) {
    const slideCount = thumbEl.querySelectorAll(".splide__slide").length;
    const toggleCentered = () => {
      if (slideCount < 4 && window.innerWidth > 768) {
        thumbEl.classList.add("is-centered");
      } else {
        thumbEl.classList.remove("is-centered");
      }
    };
    toggleCentered();
    window.addEventListener("resize", toggleCentered);
    mainEl._resizeHandler = toggleCentered;

    const thumbSlider = new Splide(thumbEl, {
      perPage: 5,
      arrows: false,
      pagination: false,
      gap: "10px",
      drag: true,
      isNavigation: true,
      breakpoints: {
        768: {
          perPage: 3,
        },
      },
    });

    mainSlider.sync(thumbSlider);
    thumbSlider.mount();
    thumbEl._splide = thumbSlider;
  }

  mainSlider.mount();
  mainEl._splide = mainSlider;
}

window.importaReinitProductGallery = function (mainEl) {
  mountProductGallery(mainEl);
};

function initProductCategoriesSlider() {
  const sliders = document.querySelectorAll(".splideProductCategories");
  if (!sliders.length) return;

  sliders.forEach((element) => {
    new Splide(element, {
      type: "slide",
      perPage: 1,
      gap: "16px",
      arrows: true,
      pagination: true,
      autoplay: false,
      drag: true,
      breakpoints: {
        768: {
          perPage: 1,
          gap: "20px",
        },
      },
    }).mount();
  });
}

function initBrandSlider() {
  const sliders = document.querySelectorAll(".splideBrand");
  if (!sliders.length) return;

  sliders.forEach((element) => {
    new Splide(element, {
      type: "slide",
      perPage: 2,
      gap: "16px",
      arrows: true,
      pagination: true,
      autoplay: false,
      drag: true,
      breakpoints: {
        480: {
          perPage: 2,
          gap: "16px",
        },
      },
    }).mount();
  });
}

function initHeroSlider() {
  const splideHeroSlider = document.querySelectorAll(".splideHeroSlider");
  splideHeroSlider.forEach((element) => {
    const autoplaySpeed = 5000;

    // Check slide count - disable loop if only 1 item
    const slideCount = element.querySelectorAll(".splide__slide").length;
    const isLoop = slideCount > 1;

    const splide = new Splide(element, {
      autoplay: isLoop,
      type: isLoop ? "loop" : "slide",
      perPage: 1,
      arrows: true,
      pagination: true,
      interval: autoplaySpeed,
      speed: 800,
      easing: "cubic-bezier(0.25, 1, 0.5, 1)",
      pauseOnHover: false,
    });

    const progressBar = element.querySelector(".splide-progress__bar");
    const progressNumber = element.querySelector(".splide-progress__number");
    const thumbnailSlides = element.querySelectorAll(".splide__thumbnail .splide__slide");
    const thumbnailContainer = element.querySelector(".splide__thumbnail");
    const heroContent = element.querySelector(".hero__content");

    let progressAnimation = null;
    let startTime = null;

    // GSAP animation for thumbnail on first load
    animateThumbnail(thumbnailContainer);

    // Animate on first load
    animateHeroContent(heroContent);

    const animateProgress = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min((elapsed / autoplaySpeed) * 100, 100);

      if (progressBar) {
        progressBar.style.setProperty('--width', `${progress}%`);
      }

      if (progress < 100) {
        progressAnimation = requestAnimationFrame(animateProgress);
      }
    };

    const startProgress = () => {
      if (progressAnimation) {
        cancelAnimationFrame(progressAnimation);
      }
      startTime = null;
      if (progressBar) {
        progressBar.style.setProperty('--width', '0%');
      }
      progressAnimation = requestAnimationFrame(animateProgress);
    };

    const stopProgress = () => {
      if (progressAnimation) {
        cancelAnimationFrame(progressAnimation);
      }
    };

    const updateSlideNumber = () => {
      if (progressNumber) {
        const currentSlide = splide.index + 1;
        const totalSlides = splide.length;
        progressNumber.textContent = `${currentSlide}/${totalSlides}`;
      }
    };

    const updateThumbnail = () => {
      if (thumbnailSlides.length > 0) {
        const nextIndex = (splide.index + 1) % splide.length;

        thumbnailSlides.forEach((slide, index) => {
          if (index === nextIndex) {
            slide.classList.add("is-active");
            slide.style.opacity = "1";
          } else {
            slide.classList.remove("is-active");
            slide.style.opacity = "0";
          }
        });
      }
    };

    // Event listeners
    splide.on("mounted", () => {
      startProgress();
      updateSlideNumber();
      updateThumbnail();
    });

    splide.on("move", () => {
      startProgress();
      updateSlideNumber();
      updateThumbnail();
      animateHeroContent(heroContent);
    });

    splide.on("autoplay:play", () => {
      startProgress();
    });

    splide.on("autoplay:pause", () => {
      stopProgress();
    });

    splide.mount();
  });
}

function initPartnerSlider() {
  const sliders = document.querySelectorAll(".splidePartnerSlider");
  if (!sliders.length) return;

  sliders.forEach((element) => {
    const slideItems = element.querySelectorAll(".splide__slide");
    const isSingle = slideItems.length <= 1;

    new Splide(element, {
      type: isSingle ? undefined : "loop",
      perPage: 1,
      arrows: !isSingle,
      pagination: false,
      autoplay: false,
      drag: !isSingle,
    }).mount();
  });
}

function initBenefitPartnerSlider() {
  const sliders = document.querySelectorAll(".splideBenefitPartner");
  if (!sliders.length) return;

  sliders.forEach((element) => {
    new Splide(element, {
      type: "slide",
      perPage: 4,
      gap: "20px",
      arrows: true,
      pagination: false,
      autoplay: false,
      drag: true,
      breakpoints: {
        768: {
          perPage: 1,
          fixedWidth: '240px',
          gap: "20px",
        },
      },
    }).mount();
  });
}

function initTermPartnerSlider() {
  const sliders = document.querySelectorAll(".splideTermPartner");
  if (!sliders.length) return;

  sliders.forEach((element) => {
    new Splide(element, {
      type: "slide",
      perPage: 1,
      gap: "20px",
      arrows: false,
      pagination: false,
      autoplay: false,
      drag: true,
      breakpoints: {
        768: {
          perPage: 1,
          fixedWidth: '240px',
          gap: "20px",
        },
      },
    }).mount();
  });
}

// function initPartnershipSlider() {
//   const splidePartnership = document.querySelectorAll(".splidePartnership");
//   if (splidePartnership.length > 0) {
//     splidePartnership.forEach((element) => {
//       try {
//         new Splide(element, {
//           type: "loop",
//           perPage: 6,
//           autoplay: true,
//           perMove: 1,
//           interval: 3000,
//           breakpoints: {
//             991: {
//               perPage: 3,
//             },
//           },
//         }).mount();
//       } catch (error) {
//         console.error("Error initializing Splide:", error);
//       }
//     });
//   }
// }

// function initTestimonySlider() {
//   const splideTestimonySlider = document.querySelectorAll(".splideTestimonySlider");
//   splideTestimonySlider.forEach((element) => {
//     new Splide(element, {
//       autoplay: true,
//       type: "loop",
//       focus: "center",
//       autoWidth: true,
//       breakpoints: {
//         991: {
//           autoWidth: false,
//           perPage: 1,
//         },
//       },
//     }).mount();
//   });
// }

// function initAboutTeamSlider() {
//   const slideAboutTeam = document.querySelectorAll(".slideAboutTeam");
//   slideAboutTeam.forEach((element) => {
//     new Splide(element, {
//       perPage: 1,
//       type: "loop",
//       gap: "1rem",
//     }).mount();
//   });
// }

// function initArticleSlider() {
//   const articleSlider = document.querySelectorAll(".article__slider");
//   articleSlider.forEach((element) => {
//     new Splide(element, {
//       perPage: 2,
//       type: 'loop',
//       autoplay: true,
//       interval: 2000,
//       gap: "12px",
//     }).mount();
//   });
// }

// function initFilterArticleSlider() {
//   const filterArticle = document.querySelectorAll(".newsUpdateTabs");
//   filterArticle.forEach((element) => {
//     new Splide(element, {
//       perPage: "auto",
//       gap: "12px",
//     }).mount();
//   });
// }
